import axios from "axios";

const api = axios.create({
  baseURL: "https://api-geral.redeprocursos.com.br/plataforma",
  headers: {
    "Content-Type": "application/json"
  },
});

export default api